import {BaseEntity,Column,Entity,Index,JoinColumn,JoinTable,ManyToMany,ManyToOne,OneToMany,OneToOne,PrimaryColumn,PrimaryGeneratedColumn,RelationId, VersionColumn, UpdateDateColumn, CreateDateColumn} from "typeorm";
import { SkuCodes } from "../sku-codes/sku-codes.entity";

@Entity('food_types')
export class 
FoodType {

  @PrimaryGeneratedColumn("increment",{name:'food_type_id'})
  foodTypeId:number;
 
  @Column("varchar",{
      nullable:false,
      length:20,
      name:"food_type"
      })
  foodType:string;

    @Column("varchar",{
      nullable:false,
      length:10,
      name:"food_type_code"
      })
    foodTypeCode:string;

    @Column("varchar",{
      nullable:false,
      length:10,
      name:"hsncode"
      })
    hsnCode:number;
   


    @Column("varchar",{
      nullable:true,
      length:50,
      name:"remarks"
      })
    remarks:string;

  @Column("boolean",{
    nullable:false,
    default:true,
    name:"is_active"
    })
  isActive:boolean;
  @CreateDateColumn({
    name: "created_at",
    type:"datetime"
  })
  createdAt: Date;

  @Column("varchar", {
      nullable: true,
      name: "created_user"
  })
  createdUser: string | null;


  @UpdateDateColumn({
      name: "updated_at",
      type:'datetime'
  })
  updatedAt: Date;

  @Column("varchar", {
      nullable: true,
      name: "updated_user"
  })
  updatedUser: string | null;


  @VersionColumn({
      default:1,
      name: "version_flag"
  })
  versionFlag: number;

  @OneToMany(type=>SkuCodes, foodType=>foodType.foodTypeId,{cascade: true})
  foodTypeInfo:SkuCodes[];
}
